export default class FasciaFormSaldiInvernali2024 {
    constructor(node) {
        this.node = node;
        this.formNode = node.querySelector('form');
        
        this.settings = window.fasciaFormSaldiInvernali2024;
        
        this.addListeners();
    }

    static init() {
        let fasciaNode = document.querySelector("[data-fascia-form-saldi-invernali-2024]");

        if (fasciaNode) {
            return new FasciaFormSaldiInvernali2024(fasciaNode);
        }
    }
    
    addListeners() {
        let _this = this;

        $(this.formNode).validate({
            callbackHandler: function (data, form)
            {
                _this.formNode.querySelector('.response-text').innerHTML = data.d.HTML;
                if (data.d.Status)
                    _this.formNode.querySelector('input[type="submit"]').style.display = 'none';
            }
        });
    }
}